import { identity } from 'ramda';
import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setPillState, resetPillsBugs } from '../../../actions/Users/UserAction';
import {
  getCasSearch,
  getOrgsSearch,
  getStatusesSearch,
  getUserRolesSearch,
  getOrganizationsByClientId,
  closeSearchFilterPanel,
} from '../../../actions/Users/UserAction';
import { getUsersList, getDefaultUsersList } from '../../../actions/Users/UserAction';
import { SUPER_USER } from '../../../actionTypes/Users/UserActionType';
import Constants from '../../../Constants';
import CollapseCust from '../../Common/Collapse/Collapse';

class SearchFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clearAllMultiSelect: false,
      collapseNumber: [],
      height: 0,
      numberOfCollapse: 5,
      numberOfSearch: 2,
      tabIndexPosition: 0,
    };
    this.closeRightNavRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && prevProps.isOpen !== this.props.isOpen) {
      this.focusToCloseButton();
      this.setState({ tabIndexPosition: 0 });
    }
  }

  closePanel = () => {
    this.props.closeSearchFilterPanel();
  };

  // setHeight = (collapseObj, status) => {
  //   let collapseNumberObj = collapseObj.collapseNumber;
  //   var checkIndex = collapseNumberObj.indexOf(collapseObj.name);
  //   if (status && checkIndex !== -1) {
  //     collapseNumberObj.splice(checkIndex, 1);
  //   } else {
  //     collapseNumberObj.push(collapseObj.name);
  //   }
  //   this.setState({
  //     collapseNumber: collapseNumberObj,
  //   });
  // }

  onFilterChange = (filterObj) => {
    this.props.setPillState(filterObj.name, true);
    this.props.getUsersList({
      pageSize: Constants.userListDefaultPageSize,
      pageNumber: 0,
      terms: {
        [filterObj.selectedName]: filterObj.clientIdsSelected,
      },
    });
  };

  clearFilterSearch = (value) => {
    this.setState({
      clearAllMultiSelect: value,
    });
  };

  clearAll = () => {
    this.clearFilterSearch(true);
    this.props.onClearAllFilters();
    this.props.getDefaultUsersList();
    this.props.resetPillsBugs();
  };

  componentDidMount() {
    this.props.getCasSearch();
    this.props.getOrgsSearch();
    this.props.getStatusesSearch();
    this.props.getUserRolesSearch();
    this.props.getOrganizationsByClientId('1896');
  }

  focusToCloseButton = () => {
    this.closeRightNavRef.current.focus();
  };

  onKeyDownTopPart = (e) => {
    if (e.key !== 'Tab' && e.key !== 'Enter') {
      e.preventDefault();
    }
    if (e.key === 'Escape') {
      this.closePanel();
    }
  };

  getSectionsCount = () => {
    const showInternalFilterSection = this.props.loggedUserDetails.userRole === SUPER_USER;
    const sectionsCount = showInternalFilterSection ? 6 : 5;
    return sectionsCount;
  };

  setFocusPosition = (newFocusPosition) => {
    const sCount = this.getSectionsCount();
    if (newFocusPosition > -1 && newFocusPosition < sCount) {
      this.setState({ tabIndexPosition: newFocusPosition });
    } else if (newFocusPosition >= sCount) {
      this.focusToCloseButton();
    }
  };

  render() {
    const { usersList, selectedFiltersOf, filterOptionsFor, userPersonated } = this.props;
    const { tabIndexPosition } = this.state;
    const isOpen = this.props.isOpen;
    const loggedUserRole = this.props.loggedUserDetails.userRole;
    const showInternalFilterSection = loggedUserRole === SUPER_USER;
    const panelClass = [
      'rightNavContainer',
      !!userPersonated ? 'top-more' : null,
      this.props.isOpen ? 'rightNavOpen' : 'rightNavClose',
    ].filter(identity);

    return (
      <div className="rightNav">
        <div className={panelClass.join(' ')}>
          <div className="filter-container">
            <div onKeyDown={this.onKeyDownTopPart} className="fiter-head row line-height-15">
              <h2
                id="filterTitle"
                className="col-sm-4 choose-filter text-center order-2 fontSm-15 bold-font ScalaSansOT-Bold">
                Choose Filter
              </h2>
              <button
                id="button-user-filter-panel-close"
                ref={this.closeRightNavRef}
                tabIndex={this.props.isOpen ? 0 : -1}
                className="actionFilter order-1"
                onKeyDown={(e) => (e.shiftKey && e.key === 'Tab' ? e.preventDefault() : void 0)}
                aria-label={'close choose filter'}
                onClick={() => this.closePanel()}>
                Close
              </button>
              <button
                id="button-user-filter-panel-reset"
                aria-label={'clear all filter'}
                tabIndex={this.props.isOpen ? 0 : -1}
                className="actionFilter order-3"
                onClick={this.clearAll}>
                Clear All
              </button>
            </div>
            <div
              tabIndex={-1}
              hidden={!this.props.isOpen}
              className="accordion"
              ref={(divElement) => (this.divElement = divElement)}>
              <CollapseCust
                hasFocus={isOpen}
                indexPosition={0}
                setFocusPosition={this.setFocusPosition}
                focusIndexPosition={tabIndexPosition}
                collapseNumber={this.state.collapseNumber}
                clearFilterSearch={this.clearFilterSearch}
                clearAllMultiSelect={this.state.clearAllMultiSelect}
                searchBar={this.props?.casOptions?.length > 7}
                filter={this.onFilterChange}
                clientIdsSelected={selectedFiltersOf.casId}
                data={this.props.casOptions}
                name="CAS"
                selectedName="casId"
                usersList={usersList}
                focusToFirstPosition={this.focusToCloseButton}
                lastCollapse={false}
              />
              <CollapseCust
                hasFocus={isOpen}
                indexPosition={1}
                setFocusPosition={this.setFocusPosition}
                focusIndexPosition={tabIndexPosition}
                collapseNumber={this.state.collapseNumber}
                clearFilterSearch={this.clearFilterSearch}
                clearAllMultiSelect={this.state.clearAllMultiSelect}
                searchBar={this.props.institutionOptions?.length > 7}
                filter={this.onFilterChange}
                clientIdsSelected={selectedFiltersOf.institutionId}
                data={this.props.institutionOptions}
                name="Institution"
                selectedName="institutionId"
                usersList={usersList}
                focusToFirstPosition={this.focusToCloseButton}
                lastCollapse={false}
              />
              <CollapseCust
                hasFocus={isOpen}
                indexPosition={2}
                setFocusPosition={this.setFocusPosition}
                focusIndexPosition={tabIndexPosition}
                collapseNumber={this.state.collapseNumber}
                clearFilterSearch={this.clearFilterSearch}
                clearAllMultiSelect={this.state.clearAllMultiSelect}
                searchBar={this.props.orgsOptions?.length > 7}
                filter={this.onFilterChange}
                clientIdsSelected={selectedFiltersOf.clientId}
                data={this.props.orgsOptions}
                name="Organization"
                selectedName="clientId"
                usersList={usersList}
                focusToFirstPosition={this.focusToCloseButton}
                lastCollapse={false}
              />
              <CollapseCust
                hasFocus={isOpen}
                indexPosition={3}
                setFocusPosition={this.setFocusPosition}
                focusIndexPosition={tabIndexPosition}
                collapseNumber={this.state.collapseNumber}
                clearFilterSearch={this.clearFilterSearch}
                clearAllMultiSelect={false}
                searchBar={false}
                filter={this.onFilterChange}
                clientIdsSelected={selectedFiltersOf.userRoleId}
                data={this.props.userRolesOptions}
                name="Role"
                selectedName="userRoleId"
                usersList={usersList}
                focusToFirstPosition={this.focusToCloseButton}
                lastCollapse={false}
              />
              <CollapseCust
                hasFocus={isOpen}
                indexPosition={4}
                setFocusPosition={this.setFocusPosition}
                focusIndexPosition={tabIndexPosition}
                collapseNumber={this.state.collapseNumber}
                clearFilterSearch={this.clearFilterSearch}
                clearAllMultiSelect={false}
                searchBar={false}
                filter={this.onFilterChange}
                clientIdsSelected={selectedFiltersOf.status}
                data={this.props.statusOptions}
                name="Status"
                selectedName="status"
                usersList={usersList}
                focusToFirstPosition={this.focusToCloseButton}
                lastCollapse={!showInternalFilterSection}
              />

              {showInternalFilterSection ? (
                <CollapseCust
                  hasFocus={isOpen}
                  indexPosition={5}
                  setFocusPosition={this.setFocusPosition}
                  focusIndexPosition={tabIndexPosition}
                  collapseNumber={this.state.collapseNumber}
                  clearFilterSearch={this.clearFilterSearch}
                  clearAllMultiSelect={false}
                  searchBar={false}
                  filter={this.onFilterChange}
                  clientIdsSelected={selectedFiltersOf.internalUser || []}
                  data={filterOptionsFor.internalUser}
                  name="Internal"
                  selectedName="internalUser"
                  usersList={usersList}
                  focusToFirstPosition={this.focusToCloseButton}
                  lastCollapse={true}
                />
              ) : (
                void 0
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    casOptions: state.Users.filterOptions.cas,
    orgsOptions: state.Users.filterOptions.orgs,
    institutionOptions: state.Users.filterOptions.institutions,
    statusOptions: state.Users.filterOptions.statuses,
    userRolesOptions: state.Users.filterOptions.userRoles,
    usersList: state.Users.usersList,
    userPersonated: state.Impersonate.impersonate.userPersonated,
    pillsBugs: state.Users.usersPills,
    selectedFiltersOf: state.Users.usersList.terms,
    filterOptionsFor: state.Users.filterOptions,
    loggedUserDetails: state.AppSession.userDetails,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCasSearch,
      getOrgsSearch,
      getStatusesSearch,
      getUserRolesSearch,
      getUsersList,
      getDefaultUsersList,
      setPillState,
      resetPillsBugs,
      closeSearchFilterPanel,
      getOrganizationsByClientId,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(SearchFilter);
